module.exports = __webpack_public_path__ + "static/img/uiux.ba57e2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/uiux.svg
// module id = n/6q
// module chunks = 1 2